export default __webpack_public_path__ + "static/media/blog2.52878759.jpg";